import React, { useState } from "react";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import { useTranslation } from "react-i18next";

import { HeaderStyles } from "./Header.style";
import { LanguageMenu } from "../LanguageMenu/LanguageMenu";
import { Drawer, DrawerNavItem } from "../Drawer/Drawer";
import { IconButton } from "@material-ui/core";

import MenuIcon from "@material-ui/icons/Menu";

// re-export the drawer nav item
export type HeaderNavItem = DrawerNavItem;

interface HeaderProps {
  title: string;
  subtitle?: string;
  navItems?: HeaderNavItem[];
  onNavigate?: (key: string) => void;
}

export const Header: React.FC<HeaderProps> = ({
  title,
  subtitle,
  navItems,
  onNavigate,
}) => {
  const styles = HeaderStyles();
  const { i18n } = useTranslation();
  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const hasNavigation = navItems !== undefined && navItems.length;

  const navigate = (page: string) => {
    if (onNavigate) onNavigate(page);
  };
  const handleDrawer = (open: boolean) => {
    setDrawerOpen(open);
  };
  const handleMenuClick = (event: React.MouseEvent<HTMLElement>) => {
    setDrawerOpen(!isDrawerOpen);
  };

  return (
    <div className={styles.root}>
      <AppBar position="static">
        <Toolbar>
          {hasNavigation ? (
            <IconButton
              color="inherit"
              aria-label="Menu"
              onClick={handleMenuClick}
            >
              <MenuIcon />
            </IconButton>
          ) : (
            <div></div>
          )}
          <div className={styles.title}>
            <Typography variant="h6">{title}</Typography>
            {subtitle !== undefined ? (
              <Typography variant="subtitle1">{subtitle}</Typography>
            ) : (
              <div></div>
            )}
          </div>
          <LanguageMenu lang={i18n.language} />
        </Toolbar>
      </AppBar>

      {hasNavigation ? (
        <Drawer
          open={isDrawerOpen}
          items={navItems ? navItems : []}
          onSelect={navigate}
          onClose={handleDrawer}
        />
      ) : (
        <div></div>
      )}
    </div>
  );
};
